import React, { FC } from 'react';
import { CandidateProfileDataItemsWithUser } from './CandidateProfileDataItemsWithUser';
import { CandidateProfileDataItemsWithApplication } from './CandidateProfileDataItemsWithApplication';
import { CandidateProfileDataItemsProps } from './props';
import './styles.scss';

export const CandidateProfileDataItems: FC<CandidateProfileDataItemsProps> = ({ applicationId, className, user }) => {
  if (applicationId) {
    return <CandidateProfileDataItemsWithApplication applicationId={applicationId} className={className} user={user} />;
  }

  return <CandidateProfileDataItemsWithUser className={className} user={user} />;
};
